export default __webpack_public_path__ + "static/Pelt-0b403e7024faf749e34467a678f919d0.png";